import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { callApi } from '../../utils/api';
import Select from 'react-select';
import { formatTime24to12 } from "../../common/commonFunctions";
declare var $: any; // for Bootstrap modal control

export default function RequestShiftExtension({ show, onClose, onSubmit, loading }) {
    const [extendedStart, setExtendedStart] = useState('');
    const [extendedEnd, setExtendedEnd] = useState('');
    const [extendedEmpId, setExtendedEmpId] = useState('');
    const [reason, setReason] = useState('');
    const [userList, setUserList] = useState([]);
    const [pageDynamic, setPageDynamic] = useState([]);
    const currentShiftEnd = localStorage.getItem("shiftEndTime") || '';
    const parsedCurrentShiftEnd = currentShiftEnd ? JSON.parse(currentShiftEnd) : '';
    const [extendedDate, setExtendedDate] = useState('');
    useEffect(() => {
        if (show) {
            $('#request-extension-modal').modal('show');
            getUsers();
            getPageDynamicData();
        } else {
            $('#request-extension-modal').modal('hide');
        }
    }, [show]);

    useEffect(() => {
        if (!show) {
            setExtendedStart('');
            setExtendedEnd('');
            setReason('');
            setExtendedDate('');
        }
    }, [show]);

    const getUsers = () => {
        callApi("GET", "user_get.php")
            .then(res => res.data)
            .then(response => {
                setUserList(response.data);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const getPageDynamicData = () => {
        const user: any = localStorage.getItem("user");
        const userDetails = user ? JSON.parse(user) : "";
        let obj = {
            roleId: userDetails ? userDetails.role_id : null,
            userId: userDetails ? userDetails.userId : null,
            roleType: userDetails ? userDetails.roleType : null,
        };
        callApi("POST", "authenticating_pages_list_new.php", obj)
            .then(res => res.data)
            .then(result => {
                setPageDynamic(result.responseJson.data);
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const user = localStorage.getItem("user");
        const role_label = user ? JSON.parse(user)["role_label"] : "";
        // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
        const isAdminAccess = pageDynamic && pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

        if (!extendedDate) {
            alert('Please select a date');
            return;
        }

        if (!extendedEmpId && isAdminAccess) {
            alert('Please select employee');
            return;
        }
        if (!extendedStart) {
            alert('Please select extended start time');
            return;
        }
        if (!extendedEnd) {
            alert('Please select extended end time');
            return;
        }
        if (dayjs(extendedEnd, 'HH:mm').isBefore(dayjs(extendedStart, 'HH:mm'))) {
            alert('Extended End Time must be after Extended Start Time.');
            return;
        }
        if (!reason.trim()) {
            alert('Please provide a reason');
            return;
        }

        onSubmit({
            extendedDate,
            extendedStart,
            extendedEnd,
            extendedEmpId,
            reason,
        });
    };

    const user = localStorage.getItem("user");
    const role_label = user ? JSON.parse(user)["role_label"] : "";
    // const isAdmin = ["Admin", "Super Admin"].includes(role_label);
    const isAdminAccess = pageDynamic && pageDynamic.find((page: any) => page.page_name === "Shift List" && page.status == true);

    return (
        <div
            className="modal fade"
            id="request-extension-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex={-1}
        >
            <div className="modal-dialog">
                <div className="modal-content" style={{ borderRadius: '10px' }}>
                    <div className="modal-header">
                        <h5 className="modal-title">Request Shift Extension</h5>
                        <button
                            type="button"
                            className="close"
                            // data-dismiss="modal"
                            // aria-label="Close"
                            onClick={onClose}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>          </div>
                    <div className="modal-body">
                        {/* {!isAdmin && */}
                        <p>
                            Current shift ends at: <b>{formatTime24to12(parsedCurrentShiftEnd)}</b>
                        </p>
                        {/* } */}

                        <form onSubmit={handleSubmit}>
                            {isAdminAccess &&
                                <div className="mb-3">
                                    <h6>Employee Name</h6>
                                    {userList && userList.length > 0 && userList.map((opt: any) => {
                                        opt.label = opt.name; opt.value = opt.id
                                    }) &&
                                        <Select options={userList} name="assigned_to"
                                            value={userList.find((o: any) => o.value === extendedEmpId)}
                                            onChange={(e) => setExtendedEmpId(e.value)}

                                        />
                                    }
                                </div>
                            }
                            <div className="mb-3">
                                <label>Extension Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={extendedDate}
                                    onChange={(e) => setExtendedDate(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label>Extended Start Time</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    value={extendedStart}
                                    onChange={(e) => setExtendedStart(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label>Extended End Time</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    value={extendedEnd}
                                    onChange={(e) => setExtendedEnd(e.target.value)}
                                />
                            </div>
                            <div className="mb-3">
                                <label>Reason for Extension</label>
                                <textarea
                                    rows={3}
                                    className="form-control"
                                    placeholder="Enter reason"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                ></textarea>
                            </div>
                            <div className="d-flex justify-content-end">
                                <button type="submit" className="btn btn-primary m-1" disabled={loading}>
                                    {loading ? (
                                        <i className="fa fa-spinner fa-spin"></i>
                                    ) : "Submit Request"}
                                </button>
                                <button type="button" className="btn btn-danger m-1" onClick={onClose}>
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
